import React, { Component } from 'react';
import Navigation from '../../Containers/Navigation/Navigation';
import Row from '../../components/Counter/Row';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import { fetchSpace } from '../../actions/index';
import Chart from '../../Containers/Chart/Chart';

let timer;
class Starbucks extends Component {
  state = {
    data: null
  };

  componentDidMount() {
    this.fetchSpace();
    timer = setInterval(() => this.fetchSpace(), 5000);
  }

  componentWillUnmount() {
    clearInterval(timer);
  }

  fetchSpace = async () => {
    const response = await fetchSpace(process.env.REACT_APP_STARBUCKS_SPACE_ID);
    if (response) {
      this.setState({
        data: response
      });
    }
  };
  render() {
    console.log(process.env.REACT_APP_STARBUCKS_VIDEO_URL);
    if (!this.state.data) {
      return <div />;
    }
    const { current_count, capacity } = this.state.data;
    const filled = (current_count / capacity) * 100;
    const rating = filled <= 50 ? 'green' : filled > 75 ? 'red' : 'yellow';
    return (
      <>
        <Navigation title="Starbucks" hours="7AM - Midnight" />
        <Row
          filled={filled ? `${Math.round(filled)}%` : null}
          current={current_count}
          capacity={capacity}
          rating={rating}
        />
        {process.env.REACT_APP_STARBUCKS_VIDEO_URL && <VideoPlayer url={process.env.REACT_APP_STARBUCKS_VIDEO_URL} />}
        <Chart spaceId={process.env.REACT_APP_STARBUCKS_SPACE_ID} />
      </>
    );
  }
}

export default Starbucks;
